import { request } from "@/plugins/axios";
import qs from 'qs';


//我的主页、订单管理 -------页面接口
// 积分管理
export async function integralManagement(opt) {
    return await request({
        url: '/api/u_i/integralManagement',
        method: 'post',
        data: opt
    })
}
// 用户信息
export async function userInfo() {
    return await request({
        url: '/api/u_i/userInfo',
        method: 'post',
    })
}
// 验货
export async function insp(parmas) {
    return await request({
        url: '/api/h_i/insp',
        method: 'get',
        params:parmas
    })
}
// 申请验货
export async function add_insp(parmas) {
    return await request({
        url: '/api/h_i/add_insp',
        method: 'post',
        data:qs.stringify(parmas)
    })
}
// 申请记录
export async function app_record(parmas) {
    return await request({
        url: '/api/h_i/app_record',
        method: 'get',
        params:parmas
    })
}
// 取消申请
export async function withdraw(parmas) {
    return await request({
        url: '/api/h_i/withdraw',
        method: 'post',
        data:qs.stringify(parmas)
    })
}
// 同城验货员
export async function inspector() {
    return await request({
        url: '/api/h_i/inspector',
        method: 'get',
    })
}
// 提现
export async function cashSubmit(parmas) {
    return await request({
        url: '/api/u_i/cash',
        method: 'post',
        data:qs.stringify(parmas)
    })
}
// 提现方式
export async function bindCash(parmas) {
    return await request({
        url: '/api/u_i/bind',
        method: 'post',
        data:qs.stringify(parmas)
    })
}

// 美元转人民币
export async function usdToCny(params) {
    return await request({
        url: '/api/u_is/usdToCny',
        method: 'post',
        data: qs.stringify(params)
    })
}


// 获取网站
export async function getHostMsg(params) {
    return await request({
        url: '/api/u_i/get_value',
        method: 'post',
        data: qs.stringify(params)
    })
}